import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiResponse, editCharacterDetail } from '~/api';
import { ApiError, EditCharacterDetailRequest, EmptyObject } from '~/types';
import useToast from '~/store/useToast';
import userKey from '../user/userKey';
import characterKey from './characterKey';

const useEditCharacterDetailMutation = () => {
  const { showToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation<
    ApiResponse<EmptyObject>,
    ApiError,
    EditCharacterDetailRequest
  >({
    mutationFn: editCharacterDetail,
    onSuccess: ({ status }) => {
      queryClient.invalidateQueries({
        queryKey: userKey.all,
      });
      queryClient.invalidateQueries({
        queryKey: characterKey.all,
      });
    },
    onError: (error) => {
      console.error(error);
      if (error.status === 400 && error.body.code === 2) {
        // profile_image 파일이 부적절한 경우
        showToast(
          'error',
          'Image upload failed. Pornographic or inappropriate images cannot be uploaded.',
        );
      } else {
        showToast('error', 'Failed to edit character detail.');
      }
    },
  });
};

export default useEditCharacterDetailMutation;
